module.exports = __webpack_public_path__ + "static/media/call.7d0980f7.svg";